import { gql } from "@apollo/client";

export const createCommunicationTemplateGql = gql`
    mutation createCommunicationTemplate($createCommunicationTemplateInput: CreateCommunicationTemplateInput!) {
        createCommunicationTemplate(createCommunicationTemplateInput: $createCommunicationTemplateInput) {
            id
        }
    }
`;

export const updateCommunicationTemplateGql = gql`
    mutation updateCommunicationTemplate(
        $updateCommunicationTemplateInput: UpdateCommunicationTemplateInput!
        $usePreview: Boolean!
    ) {
        updateCommunicationTemplate(updateCommunicationTemplateInput: $updateCommunicationTemplateInput) {
            id
            name
            description
            channel
            state
            emailSubject
            body
            bodySource @include(if: $usePreview)
            teams {
                id
                name
            }
        }
    }
`;
